import React from 'react';
const contexts = ['Escuelas Públicas', 'Colegios Privados', 'Institutos Técnicos', 'Bachilleratos', 'Escuelas de Adultos', 'Educación a Distancia'];
export function SocialProofBar() {
  return <div className="bg-[#1e293b] pt-0 pb-6" data-id="element-131">
      <div className="max-w-lg mx-auto px-4" data-id="element-132">
        <p className="text-center text-slate-400 text-[11px] font-medium italic mb-2.5" data-id="element-133">
          Utilizado en todo tipo de contextos:
        </p>
        <div className="flex flex-wrap justify-center gap-1.5" data-id="element-134">
          {contexts.map(ctx => <span key={ctx} className="border border-slate-600 text-slate-300 text-[10px] md:text-[11px] font-medium px-2.5 py-1 rounded-full" data-id="element-135">
              {ctx}
            </span>)}
        </div>
      </div>
    </div>;
}